import React from 'react';
import { GUEST_PATH } from '../../../../constants';

const Cart = React.lazy(() => import('./index'));

const routes = {
     path: GUEST_PATH.CART, // Must have 1 path with '/', so useRoutes of react-router-dom won't cause issues
     breadcrumb: 'Cart', // To display for breadcrumb
     element: <Cart />,
};

export default routes;
